import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";
import { useI18n } from "@/i18n";

export default function Layout({ children }) {
  const { lang, t } = useI18n();

  useEffect(() => {
    document.documentElement.lang = lang === "ar" ? "es-AR" : "en";
    const title = t("meta.title");
    if (title) document.title = title;
    const description = t("meta.description");
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
  }, [lang, t]);

  return (
    <div className="min-h-screen flex flex-col bg-[#F8F9FA] text-slate-900">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
